angular
    .module('admin.reports')

    .constant('dateRangePickerConfig', {
        applyClass: 'btn-sm btn-primary',
        alwaysShowCalendars: true,
        autoApply: true,
        showDropdowns: true,
        locale: {
            applyLabel: 'Aplicar',
            fromLabel: 'De',
            format: 'DD/MM/YYYY',
            toLabel: 'Até',
            cancelLabel: 'Cancelar',
            customRangeLabel: 'Personalizado',
            weekLabel: 'W',
            daysOfWeek: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: [
                'Janeiro',
                'Fevereiro',
                'Março',
                'Abril',
                'Maio',
                'Junho',
                'Julho',
                'Agosto',
                'Setembro',
                'Outubro',
                'Novembro',
                'Dezembro',
            ],
        },
        ranges: {
            'Última semana': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 dias': [moment().subtract(30, 'day')],
            'Este mês': [moment().startOf('month'), moment()],
            'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            'Este ano': [moment().startOf('year'), moment()],
        },
    })
    .controller('SubscriptionsFlowReportCtrl', function (dateRangePickerConfig, ReportsResource, $http, config) {
        const baseColors = ['#5cb1e6', '#ff9900', '#5ead5d', '#8B54DD', '#e55430', '#ff6b6b', '#4ecdc4', '#f9ca24']

        const generateColors = function (count) {
            let colors = []

            for (var i = 0; i < count; i++) {
                if (i < baseColors.length) {
                    colors.push(baseColors[i])
                } else {
                    var hue = (i * 137.508) % 360
                    colors.push('hsl(' + hue + ', 70%, 50%)')
                }
            }

            return colors
        }

        const capitalizeString = function (str) {
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
            })
        }

        this.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.loadReport()
                },
            },
        })

        this.filter = {
            period: {
                startDate: moment().subtract(30, 'day').toDate(),
                endDate: moment().toDate(),
            },
        }

        this.tablesTabs = [
            { action: 'Subscribe', title: 'Assinou' },
            { action: 'ChangePlan', title: 'Mudou de Plano' },
            { action: 'Unsubscribe', title: 'Cancelou' },
            { title: 'Todos' },
        ]

        this.getFilterRequest = function () {
            var filter = angular.copy(this.filter)
            filter.period = {
                startDate: moment(this.filter.period.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.filter.period.endDate).format('YYYY-MM-DD'),
            }
            return filter
        }

        this.loadReport = function () {
            delete this.report
            delete this.reportData
            this.loading = true

            var filter = this.getFilterRequest()
            delete this.reportAvailable
            ReportsResource.subscriptionFlow(filter, (data) => {
                this.loading = false
                this.report = data
                if (data.success) {
                    this.report = data

                    this.charts = {
                        barChart: this.createBarChart(data),
                        lineChart: this.createLineChart(data),
                        pieChart: this.createPieChart(data),
                        pfVsPjChart: this.createPfVsPjPieChart(data),
                    }
                }
            })
        }
        this.loadTables = function () {
            delete this.reportData
            var filter = this.getFilterRequest()
            this.tableLoading = true
            ReportsResource.subscriptionFlowData(filter, (data) => {
                this.reportData = data
                this.tableLoading = false
            })
        }

        this.exportTable = function () {
            let action = this.activeTable

            const filter = Object.assign(
                {
                    historyAction: action,
                },
                this.getFilterRequest()
            )
            $http({
                url: config.api + '/api/AdminSubscriptionFlowReport/GetExcel',
                data: filter,
                method: 'POST',
                responseType: 'arraybuffer',
            }).then((res) => {
                res.headers()
                var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }))
                var a = document.createElement('a')
                a.href = url
                a.download = `FluxoAssinaturas.xlsx`
                a.target = '_blank'
                a.click()
            })
        }

        this.createBarChart = function (data) {
            var chart = {
                chart: {
                    type: 'bar',
                },
                title: {
                    text: 'Assinaturas x Cancelamentos',
                },
                xAxis: {
                    categories: data.periodReport.categories,
                    title: {
                        text: null,
                    },
                },
                yAxis: {
                    min: 0,
                },
                tooltip: {
                    valueSuffix: '',
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                        },
                    },
                },
                series: data.periodReport.series,
            }
            return chart
        }
        this.createLineChart = function (data) {
            var chart = {
                colors: ['#5ead5d', '#8B54DD', '#e55430'],
                chart: {
                    type: 'line',
                },
                title: {
                    text: 'Evolução Mês a Mês',
                },
                xAxis: {
                    categories: data.timeline.categories,
                    title: {
                        text: 'Meses',
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Qtde',
                    },
                },
                tooltip: {
                    valueSuffix: ' por mês',
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                        },
                    },
                },
                series: data.timeline.series,
            }
            return chart
        }

        this.createPieChart = function (data) {
            // Converte o objeto de planos dinâmicos em array para o gráfico
            let plansData = []

            if (data.plans && data.plans.plans) {
                for (var planName in data.plans.plans) {
                    if (data.plans.plans.hasOwnProperty(planName)) {
                        plansData.push({
                            name: capitalizeString(planName),
                            y: data.plans.plans[planName],
                        })
                    }
                }
            }

            return {
                colors: generateColors(plansData.length),
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                },
                title: {
                    text: 'Novos Planos',
                },
                tooltip: {
                    pointFormat: '{series.name}: {point.y} <b>{point.percentage:.1f}%</b>',
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false,
                        },
                        showInLegend: true,
                    },
                },
                series: [
                    {
                        name: 'Planos',
                        colorByPoint: true,
                        data: plansData,
                    },
                ],
            }
        }
    })
    .controller('SubscriptionsFlowReportCtrl',
        function (dateRangePickerConfig, ReportsResource, $http, config, $scope) {

            this.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
                eventHandlers: {
                    'apply.daterangepicker': () => {
                        this.loadReport();
                    }
                }
            });

            this.filter = {
                period: {
                    startDate: moment().subtract(30, 'day').toDate(),
                    endDate: moment().toDate()
                }
            };

            this.page = 1;
            this.pageSize = 20;
            this.search = '';
            this.activeTable = 0;
            this.personType = null;

            this.tablesTabs = [
                { action: 'SUBSCRIBED', title: 'Assinou' },
                { action: 'PLAN_CHANGED', title: 'Mudou de Plano' },
                { action: 'CANCELLED', title: 'Cancelou' },
                { action: 'ALL', title: 'Todos' }
            ];

            this.getFilterRequest = function () {
                var filter = angular.copy(this.filter);
                filter.period = {
                    startDate: moment(this.filter.period.startDate).format('YYYY-MM-DD'),
                    endDate: moment(this.filter.period.endDate).format('YYYY-MM-DD')
                };
                return filter;
            }

            this.loadReport = function () {

                delete this.report
                delete this.reportData
                this.loading = true;

                const filter = this.getFilterRequest();
                delete this.reportAvailable;

                const params = {
                    startDate: filter.period.startDate,
                    endDate: filter.period.endDate
                };
                ReportsResource.subscriptionFlowCharts(params, (response) => {
                    this.loading = false
                    if (response.statusCode === 200 && response.data) {
                        this.report = response.data;
                        // Set success flag for template compatibility
                        this.report.success = true;

                        this.charts = {
                            barChart: this.createBarChart(response.data),
                            lineChart: this.createLineChart(response.data),
                            pieChart: this.createPieChart(response.data),
                            pfVsPjChart: this.createPfVsPjPieChart(response.data)
                        };
                    } else {
                        // Set report with success false to show the warning message
                        this.report = { success: false };
                    }
                });
            };

            this.loadTables = function () {
                if (this.tableLoading) return;
                delete this.reportData

                const filter = this.getFilterRequest();
                this.tableLoading = true

                const params = {
                    startDate: filter.period.startDate,
                    endDate: filter.period.endDate,
                    page: this.page,
                    pageSize: this.pageSize
                };

                const activeTab = this.tablesTabs[this.activeTable];
                if (activeTab && activeTab.action) {
                    params.action = activeTab.action;
                }

                if (this.search) {
                    params.search = this.search;
                }

                if (this.personType) {
                    params.personType = this.personType;
                }

                ReportsResource.subscriptionFlowData(params, (response) => {
                    this.tableLoading = false;
                    if (response.statusCode === 200 && response.data) {
                        this.reportData = response.data.data;
                        this.reportMetadata = response.data.metadata;
                        return;
                    }

                    this.reportData = [];
                    this.reportMetadata = { total: 0, page: 1, limit: 20, totalPages: 0 };
                });
            }

            $scope.$watch('ctrl.activeTable', (newVal, oldVal) => {
                if (newVal !== oldVal && !this.tableLoading) {
                    this.page = 1;
                    this.search = '';
                    this.loadTables();
                }
            });

            this.onPersonTypeChange = function () {
                this.page = 1;
                this.loadTables();
            }

            this.onPageChange = function () {
                this.loadTables();
            }

            this.onSearch = function () {
                this.page = 1;
                this.loadTables();
            }

            this.exportTable = function () {
                var activeTab = this.tablesTabs[this.activeTable];
                var action = activeTab ? activeTab.action : null;

                const filter = this.getFilterRequest();
                const params = {
                    startDate: filter.period.startDate,
                    endDate: filter.period.endDate
                };

                if (action) {
                    params.action = action;
                }

                if (this.search) {
                    params.search = this.search;
                }

                if (this.personType) {
                    params.personType = this.personType;
                }

                $http({
                    url: config.api + '/api/v1/reports/subscription-flow/export',
                    method: 'GET',
                    params: params,
                    responseType: 'arraybuffer'
                }).then((res) => {
                    var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = `FluxoAssinaturas.csv`;
                    a.target = '_blank';
                    a.click();
                });
            }

            this.createBarChart = function (data) {
                var chart = {
                    chart: {
                        type: 'bar'
                    },
                    title: {
                        text: 'Assinaturas x Cancelamentos'
                    },
                    xAxis: {
                        categories: ['Assinaturas', "Mudança de Plano", 'Cancelamentos'],
                    },
                    yAxis: {
                        title: {
                            text: null
                        }
                    },
                    yAxis: {
                        min: 0
                    },
                    tooltip: {
                        valueSuffix: ''
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    },
                    series: [{
                        name: 'Valores',
                        color: '#7cb5ec',
                        data: [
                            data.subscriptionsVsCancellations.subscriptions,
                            data.subscriptionsVsCancellations.planChanges,
                            data.subscriptionsVsCancellations.cancellations
                        ]
                    }]
                };
                return chart;

            };
            this.createLineChart = function (data) {
                var chart = {
                    colors: ['#5ead5d', '#8B54DD', '#e55430'],
                    chart: {
                        type: 'line'
                    },
                    title: {
                        text: 'Evolução Mês a Mês'
                    },
                    xAxis: {
                        categories: data.timeline.categories,
                        title: {
                            text: 'Meses'
                        }
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Qtde'
                        }
                    },
                    tooltip: {
                        valueSuffix: ' por mês'
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    },
                    series: data.timeline.series
                };
                return chart;
            }

            this.createPieChart = function (data) {

                var baseColors = [
                    '#5cb1e6',
                    '#ff9900',
                    '#5ead5d',
                    '#8B54DD',
                    '#e55430',
                    '#ff6b6b',
                    '#4ecdc4',
                    '#45b7d1',
                    '#f9ca24',
                ];

                this.generateColorVariant = function (hexColor, variantIndex) {
                    // Convert hex to RGB
                    var r = parseInt(hexColor.substr(1, 2), 16);
                    var g = parseInt(hexColor.substr(3, 2), 16);
                    var b = parseInt(hexColor.substr(5, 2), 16);

                    // Adjust brightness: alternate between darker and lighter variants
                    var brightnessFactor = variantIndex % 2 === 0 ? 0.7 : 1.3;

                    // Apply brightness adjustment
                    r = Math.min(255, Math.max(0, Math.round(r * brightnessFactor)));
                    g = Math.min(255, Math.max(0, Math.round(g * brightnessFactor)));
                    b = Math.min(255, Math.max(0, Math.round(b * brightnessFactor)));

                    // Convert back to hex
                    var toHex = function (n) {
                        var hex = Math.round(n).toString(16);
                        return hex.length === 1 ? '0' + hex : hex;
                    };

                    return '#' + toHex(r) + toHex(g) + toHex(b);
                }

                this.generateColorsArray = function (planCount) {
                    // Generate colors array: use base colors, then generate variants if needed
                    var colors = baseColors.slice();
                    if (planCount > baseColors.length) {
                        var additionalColorsNeeded = planCount - baseColors.length;
                        for (var i = 0; i < additionalColorsNeeded; i++) {
                            // Generate dynamic variants by cycling through base colors with varying brightness
                            var baseColorIndex = i % baseColors.length;
                            var baseColor = baseColors[baseColorIndex];
                            var variantIndex = Math.floor(i / baseColors.length) + 1;
                            // Create variant by adjusting brightness (darker/lighter)
                            var variant = this.generateColorVariant(baseColor, variantIndex);
                            colors.push(variant);
                        }
                    }
                    return colors;
                }

                var colors = this.generateColorsArray(data.planDistribution.plans.length);
                var planData = data.planDistribution.plans.map(function (plan) {
                    return {
                        name: plan.planName,
                        y: plan.subscriptions
                    };
                });

                return {
                    colors: colors,
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie'
                    },
                    title: {
                        text: 'Novos Planos'
                    },
                    tooltip: {
                        pointFormat: '{series.name}: {point.y} <b>{point.percentage:.1f}%</b>'
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        name: 'Planos',
                        colorByPoint: true,
                        data: planData
                    }]
                };
            }

            this.createPfVsPjPieChart = function (data) {
                return {
                    colors: ['#ff9900', '#5cb1e6'],
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie'
                    },
                    title: {
                        text: 'Novas Assinaturas: Pessoa Física x Jurídica'
                    },
                    tooltip: {
                        pointFormat: '{series.name}: {point.y} <b>{point.percentage:.1f}%</b>'
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        name: 'Planos',
                        colorByPoint: true,
                        data: [{
                            name: 'Pessoa Física',
                            y: data.subscriptionTypes.individual
                        }, {
                            name: 'Pessoa Jurídica',
                            y: data.subscriptionTypes.corporate
                        }]
                    }]
                };
            }

            this.loadReport()
        })
